class DreambabyEmailExistsHandler {
  constructor() {
    this.emailValue = '';
    this.errorModal = document.querySelector('.form-errors-modal.loyalty-modal');
    this.closeModalXButton = this.errorModal ? this.errorModal.querySelector('.close-modal-x') : null;
    this.closeModalButton = this.errorModal ? this.errorModal.querySelector('.close-modal-button') : null;

    this.loyaltyCheckbox = document.getElementById('loyalty');
    this.marketingCheckbox = document.getElementById('marketing');

    this.existingLoyalty = false;
    this.existingMarketing = false;
    this.consentStatusReady = false;
    this.skipEmailCheck = false;
    this.isProceedingToNativeSubmit = false;

    const giftlistDomain = window.DreambabyConfig && window.DreambabyConfig.giftlistDomain;

    this.form = document.getElementById('create_customer');
    this.submitButton = this.form
      ? this.form.querySelector('.register-submit-button, button[type="submit"], button.button')
      : null;
    this.emailInput = document.querySelector(
      'input[name="customer[email]"], input[type="email"], #RecoverEmail, input#recover-email'
    );
    this.passwordModal = document.getElementById('password-modal');

    this.adminHandler = new DreambabyAdminRequestHandler();
    this.customerInviteHandler = new DreambabyCustomerMailHandler({
      endpointUrl: `${giftlistDomain}/proxy/shopify-admin/customer-invite?authorization=fixed`,
      proxyToken: window.DreambabyConfig && window.DreambabyConfig.proxyToken
    });

    this.init();
  }

  init() {
    this.setupEmailSync();
    this.setupErrorModalClose();
    this.setupSuccessModalClose();
    this.setupRequestPassword();
    this.setupCheckboxesSync();
    this.setupPreSubmitEmailCheck();

    if (!this.errorModal) {
      return;
    }

    this.setupLoyaltyModal();
    this.setupLoyaltyCheckboxHandler();
  }

  setupPreSubmitEmailCheck() {
    if (!this.form || !this.errorModal) {
      return;
    }

    this.form.addEventListener('submit', async (event) => {
      if (this.skipEmailCheck) {
        this.skipEmailCheck = false;
        return;
      }

      event.preventDefault();

      const email = (this.emailInput?.value || this.emailValue || '').trim();
      if (!email) {
        this.continueNativeSubmit();
        return;
      }

      this.emailValue = email;
      sessionStorage.setItem('dreambaby_email', email);
      this.setSubmitLoading(true);

      try {
        const status = await this.adminHandler.getCustomerConsentStatus(email);

        if (status.exists) {
          this.resetPasswordModalState();
          this.applyConsentStatus(status);
          this.consentStatusReady = true;
          this.fadeInModal(this.errorModal);
          return;
        }

        this.continueNativeSubmit();
      } catch (error) {
        console.error(
          '[DreambabyEmailExistsHandler] Pre-submit email check failed, falling back to native submit:',
          error
        );
        this.continueNativeSubmit();
      } finally {
        if (!this.isProceedingToNativeSubmit) {
          this.setSubmitLoading(false);
        }
      }
    });
  }

  continueNativeSubmit() {
    this.isProceedingToNativeSubmit = true;
    this.skipEmailCheck = true;

    if (this.form.closest('.dreambaby-goodiebag')) {
      sessionStorage.setItem('dreambabyPendingPasswordSetup', 'true');
    }

    if (typeof this.form.requestSubmit === 'function') {
      this.form.requestSubmit();
      return;
    }
    this.form.submit();
  }

  setSubmitLoading(isLoading) {
    if (!this.submitButton) {
      return;
    }
    this.submitButton.disabled = isLoading;
    this.submitButton.classList.toggle('loading', isLoading);
  }

  resetPasswordModalState() {
    if (!this.passwordModal) {
      return;
    }

    this.hideModal(this.passwordModal);

    const errorPanel = this.passwordModal.querySelector('.form-message--error');
    const successPanel = this.passwordModal.querySelector('.form__success');
    if (errorPanel) {
      errorPanel.style.display = '';
    }
    if (successPanel) {
      successPanel.style.display = '';
      successPanel.classList.remove('is-visible');
    }
    if (this.requestPasswordButton) {
      this.requestPasswordButton.classList.remove('loading');
    }
  }

  setupSuccessModalClose() {
    if (!this.passwordModal) {
      return;
    }

    const closeModal = () => this.fadeOutModal(this.passwordModal);

    [
      this.passwordModal.querySelector('.close-modal-x'),
      this.passwordModal.querySelector('.close-modal-button'),
      this.passwordModal.querySelector('.close-success-modal-button')
    ].forEach((button) => {
      if (button) {
        button.addEventListener('click', closeModal);
      }
    });

    this.passwordModal.addEventListener('click', (event) => {
      if (event.target === this.passwordModal) {
        closeModal();
      }
    });
  }

  setupLoyaltyModal() {
    this.loyaltyModalError = this.errorModal.querySelector('.loyalty-modal-error');
    this.confirmLoyaltyButton = this.errorModal.querySelector('#confirm-loyalty-button');

    if (!this.confirmLoyaltyButton || !this.loyaltyModalLoyaltyCheckbox || !this.loyaltyModalMarketingCheckbox) {
      return;
    }

    this.updateLoyaltyConfirmButton();

    this.loyaltyModalLoyaltyCheckbox.addEventListener('change', () => {
      this.updateLoyaltyConfirmButton();
    });

    this.loyaltyModalMarketingCheckbox.addEventListener('change', () => {
      this.updateLoyaltyConfirmButton();
    });

    this.confirmLoyaltyButton.addEventListener('click', () => {
      this.confirmLoyaltyButton.classList.add('loading');
      this.updateCustomerConsent();
    });

    if (window.getComputedStyle(this.errorModal).display !== 'none') {
      this.fetchExistingConsentStatus();
    }
  }

  setupLoyaltyCheckboxHandler() {
    if (!this.loyaltyModalLoyaltyCheckbox || !this.loyaltyModalMarketingCheckbox) {
      return;
    }

    new DreambabyLoyaltyCheckboxHandler(
      this.loyaltyModalLoyaltyCheckbox.id,
      this.loyaltyModalMarketingCheckbox.id
    );
  }

  setupCheckboxesSync() {
    if (!this.errorModal) {
      return;
    }

    this.loyaltyModalLoyaltyCheckbox = this.errorModal.querySelector('#loyalty-modal-loyalty');
    this.loyaltyModalMarketingCheckbox = this.errorModal.querySelector('#loyalty-modal-marketing');

    if (!this.loyaltyModalLoyaltyCheckbox || !this.loyaltyModalMarketingCheckbox) {
      return;
    }

    const loyaltyChecked = sessionStorage.getItem('registrationLoyalty') === 'true';
    const marketingChecked = sessionStorage.getItem('registrationMarketing') === 'true';

    this.loyaltyModalLoyaltyCheckbox.checked = loyaltyChecked;
    this.loyaltyModalMarketingCheckbox.checked = marketingChecked;

    if (this.loyaltyCheckbox) {
      this.loyaltyCheckbox.checked = loyaltyChecked;
      this.setupCheckboxSync(this.loyaltyCheckbox, this.loyaltyModalLoyaltyCheckbox, 'registrationLoyalty');
    }

    if (this.marketingCheckbox) {
      this.marketingCheckbox.checked = marketingChecked;
      this.setupCheckboxSync(this.marketingCheckbox, this.loyaltyModalMarketingCheckbox, 'registrationMarketing');
    }
  }

  setupCheckboxSync(checkboxA, checkboxB, storageKey) {
    if (!checkboxA || !checkboxB) {
      return;
    }

    const syncState = (event) => {
      const isChecked = event.target.checked;
      sessionStorage.setItem(storageKey, isChecked);

      [checkboxA, checkboxB].forEach((checkbox) => {
        if (checkbox === event.target || checkbox.disabled) {
          return;
        }
        checkbox.checked = isChecked;
      });
    };

    checkboxA.addEventListener('change', syncState);
    checkboxB.addEventListener('change', syncState);
  }

  updateCustomerConsent() {
    if (!this.consentStatusReady) {
      this.loyaltyModalError.classList.remove('is-hidden');
      this.confirmLoyaltyButton.classList.remove('loading');
      this.fetchExistingConsentStatus();
      return;
    }

    const acceptsLoyalty = this.existingLoyalty
      ? true
      : !!this.loyaltyModalLoyaltyCheckbox.checked;

    this.adminHandler
      .updateCustomerConsent(
        this.emailValue,
        acceptsLoyalty,
        !!this.loyaltyModalMarketingCheckbox.checked
      )
      .then(() => {
        this.loyaltyModalError.classList.add('is-hidden');
        this.fadeOutModal(this.errorModal);

        const passwordHeader = this.passwordModal.querySelector('.password-modal-header');
        if (passwordHeader) {
          setTimeout(() => passwordHeader.classList.add('is-visible'), 500);
        }
        this.fadeInModal(this.passwordModal);
      })
      .catch((error) => {
        this.loyaltyModalError.classList.remove('is-hidden');
        console.error('Error updating customer consent:', error);
      })
      .finally(() => {
        this.confirmLoyaltyButton.classList.remove('loading');
      });
  }

  applyConsentStatus(status) {
    this.existingLoyalty = !!status.loyalty;
    this.existingMarketing = !!status.marketing;

    this.loyaltyModalLoyaltyCheckbox.checked = this.existingLoyalty;
    if (this.loyaltyCheckbox) {
      this.loyaltyCheckbox.checked = this.existingLoyalty;
    }
    this.syncLoyaltyCheckboxLock();

    this.loyaltyModalMarketingCheckbox.checked = this.existingMarketing;
    if (this.marketingCheckbox) {
      this.marketingCheckbox.checked = this.existingMarketing;
    }

    this.updateLoyaltyConfirmButton();
    this.loyaltyModalError.classList.add('is-hidden');
  }

  syncLoyaltyCheckboxLock() {
    if (!this.loyaltyModalLoyaltyCheckbox) {
      return;
    }

    const lockLoyalty = this.existingLoyalty;
    this.loyaltyModalLoyaltyCheckbox.checked = this.existingLoyalty;
    this.loyaltyModalLoyaltyCheckbox.disabled = lockLoyalty;
    this.loyaltyModalLoyaltyCheckbox.classList.toggle('is-disabled', lockLoyalty);
  }

  async fetchExistingConsentStatus() {
    if (!this.emailValue) {
      this.consentStatusReady = true;
      return;
    }

    this.setLoyaltyModalLoading(true);

    try {
      const status = await this.adminHandler.getCustomerConsentStatus(this.emailValue);

      if (!status.exists) {
        this.consentStatusReady = false;
        this.loyaltyModalError.classList.remove('is-hidden');
        return;
      }

      this.applyConsentStatus(status);
      this.consentStatusReady = true;
    } catch (error) {
      console.error('[DreambabyEmailExistsHandler] Error fetching existing consent status:', error);
      this.consentStatusReady = false;
      this.loyaltyModalError.classList.remove('is-hidden');
    } finally {
      this.setLoyaltyModalLoading(false);
    }
  }

  setLoyaltyModalLoading(isLoading) {
    this.confirmLoyaltyButton.disabled = isLoading;
    this.confirmLoyaltyButton.classList.toggle('loading', isLoading);
    this.loyaltyModalMarketingCheckbox.disabled = isLoading;

    if (isLoading) {
      this.loyaltyModalLoyaltyCheckbox.disabled = true;
      return;
    }

    this.syncLoyaltyCheckboxLock();
  }

  setupErrorModalClose() {
    if (!this.errorModal) {
      return;
    }

    const closeModal = () => this.fadeOutModal(this.errorModal);

    if (this.closeModalXButton) {
      this.closeModalXButton.addEventListener('click', closeModal);
    }

    if (this.closeModalButton) {
      this.closeModalButton.addEventListener('click', closeModal);
    }

    this.errorModal.addEventListener('click', (event) => {
      if (event.target === this.errorModal) {
        closeModal();
      }
    });
  }

  setupRequestPassword() {
    this.requestPasswordButton = this.passwordModal
      ? this.passwordModal.querySelector('.request-password')
      : null;
    if (!this.requestPasswordButton) {
      return;
    }

    this.requestPasswordButton.addEventListener('click', () => {
      if (!this.emailValue?.trim() || !this.passwordModal) {
        return;
      }

      this.requestPasswordButton.classList.add('loading');
      this.customerInviteHandler.triggerResetPassword(this.emailValue);
      setTimeout(() => {
        this.customerInviteHandler.triggerActivateAccount(this.emailValue);
      }, 2000);
      this.handleMailSuccess();
    });
  }

  handleMailSuccess() {
    if (!this.passwordModal) {
      return;
    }

    this.passwordModal.querySelector('.form__success').style.display = 'flex';
    this.passwordModal.querySelector('.form__success').classList.add('is-visible');
    this.passwordModal.querySelector('.form-message--error').style.display = 'none';
    this.passwordModal.style.display = 'flex';
  }

  setupEmailSync() {
    if (!this.emailInput) {
      return;
    }

    const emailFromStorage = sessionStorage.getItem('dreambaby_email');
    if (emailFromStorage) {
      this.emailInput.value = emailFromStorage;
      this.emailValue = emailFromStorage;
    } else {
      this.emailValue = this.emailInput.value;
    }

    this.emailInput.addEventListener('input', () => {
      this.emailValue = this.emailInput.value;
      if (this.emailValue) {
        sessionStorage.setItem('dreambaby_email', this.emailValue);
      } else {
        sessionStorage.removeItem('dreambaby_email');
      }
    });
  }

  updateLoyaltyConfirmButton() {
    const hasChecked =
      this.loyaltyModalLoyaltyCheckbox.checked || this.loyaltyModalMarketingCheckbox.checked;
    const label = hasChecked
      ? this.confirmLoyaltyButton.getAttribute('data-button-text-with-checkboxes')
      : this.confirmLoyaltyButton.getAttribute('data-button-text-no-checkboxes');
    this.confirmLoyaltyButton.querySelector('.button__text').innerHTML = label;
  }

  hideModal(modal) {
    if (!modal) {
      return;
    }

    if (modal._fadeOutTimeout) {
      clearTimeout(modal._fadeOutTimeout);
      modal._fadeOutTimeout = null;
    }

    modal.style.display = 'none';
    modal.classList.remove('fade-out');
    const innerModal = modal.querySelector('.form-errors-modal-inner');
    if (innerModal) {
      innerModal.classList.remove('fade-in', 'fade-out');
    }
  }

  fadeInModal(modal) {
    if (!modal) {
      return;
    }

    this.hideModal(modal);
    modal.style.display = 'flex';

    const innerModal = modal.querySelector('.form-errors-modal-inner');
    if (!innerModal) {
      return;
    }

    innerModal.classList.add('fade-in');
    const onEnd = (event) => {
      if (event.target !== innerModal) {
        return;
      }
      innerModal.classList.remove('fade-in');
      innerModal.removeEventListener('animationend', onEnd);
    };
    innerModal.addEventListener('animationend', onEnd);
  }

  fadeOutModal(modal) {
    if (!modal || modal.style.display === 'none') {
      this.hideModal(modal);
      return;
    }

    const innerModal = modal.querySelector('.form-errors-modal-inner');
    if (!innerModal) {
      this.hideModal(modal);
      return;
    }

    const onEnd = (event) => {
      if (event.target !== innerModal) {
        return;
      }
      innerModal.removeEventListener('animationend', onEnd);
      this.hideModal(modal);
    };

    innerModal.addEventListener('animationend', onEnd);
    modal.classList.add('fade-out');
    modal._fadeOutTimeout = setTimeout(() => this.hideModal(modal), 300);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DreambabyEmailExistsHandler();
  });
} else {
  new DreambabyEmailExistsHandler();
}
